import { ITheme } from '../models/ITheme.js';

export function getComponentClassName<K extends keyof Omit<ITheme, 'fontFaces'>>(
	categoryKey: K,
	componentKey: string,
	...childKeys: string[]
): string {
	if (childKeys && childKeys.length > 0) {
		return `-ksys-${childKeys[childKeys.length - 1]}`;
	}
	return `-ksys-${categoryKey}-${componentKey}`;
}